<template>
<div class="chapter">
<div class="inner_page">
<div id="Copyright" style="font-size:75%;">
<p class="copy">Copyright © Steve R Dunn 2016<span epub:type="pagebreak" id="page4"></span></p>
<p class="copy1">First published in Great Britain in 2016 by<br/>Seaforth Publishing,<br/>Pen &amp; Sword Books Ltd,<br/>47 Church Street,<br/>Barnsley S70 2AS</p>
<p class="copy1"><a href="http://www.seaforthpublishing.com" target="_blank">www.seaforthpublishing.com</a></p>
<p class="copy1"><i>British Library Cataloguing in Publication Data</i><br/>A catalogue record for this book is available from the British Library</p>
<p class="copy1">ISBN: 978 1 84832 340 7<br/>
PDF ISBN: 978 1 84832 343 8<br/>
EPUB ISBN: 978 1 84832 342 1<br/>
PRC ISBN: 978 1 84832 341 4</p>
<p class="copy1">All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or any information storage and retrieval system, without prior permission in writing of both the copyright owner and the above publisher.</p>
<p class="copy1">The right of Steve Dunn to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copy1">Typeset and designed by Mousemat Design<br/>Printed and bound in Great Britain by CPI Group (UK) Ltd,<br/>Croydon, CR0 4YY</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?3107e7e8